import {h} from 'preact';
import constants from "../../constants";

export default function FacebookIcon() {
  return <img className="share-icon" src={constants.appPrefix + "/image/fb_logo.png"}></img>;
}
